import { Api } from "@webapp/util/Api"
import { useTokenManager } from "@webapp/auth/TokenManager"
import { Environment } from "@webapp/util/Environment"

export function useSyncServiceApi() {
    const tokenManager = useTokenManager()

    return new Api(Environment.get('SYNC_URL'), tokenManager.getAccessTokenAsync)
}
